import { Helmet } from 'react-helmet-async';

import { ForgotPassword } from 'src/sections/forgot-password';

// ----------------------------------------------------------------------

export default function ForgotPasswordPage() {
  return (
    <>
      <Helmet>
        <title> Forgot Password |  Automarket </title>
      </Helmet>

      <ForgotPassword />
    </>
  );
}
